module.exports = __webpack_public_path__ + "img/bg3.bce9deec.jpg";